import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getEvents } from "../../services/clients";
import EventsTable from "../../components/Tables/EventsTable";

export const Events = () => {
  const { selectedClient } = useContext(AppContext);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setEvents(
          await getEvents(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchEvents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <EventsTable events={events} />
    </div>
  );
};

export default Events;
